module.exports = __webpack_public_path__ + "static/img/card2.bec85e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/card2.jpg
// module id = 9x6S
// module chunks = 1